import { type FC } from 'react';
import { selectQuarryLevelUpData } from '@redux/selectors/quarrySelectors';
import { useAppSelector } from '@redux/store';
import cn from 'classnames';

import { CompareResourceLevelUp } from '../CompareResourceLevelUp/CompareResourceLevelUp';

interface QuarryUpgradeInfoProps {
  id?: string;
  withNext?: boolean;
  className?: string;
}

const QuarryUpgradeInfo: FC<QuarryUpgradeInfoProps> = ({
  id,
  withNext = false,
  className,
}) => {
  const compaireOptions = useAppSelector((state) =>
    selectQuarryLevelUpData(state, { resourceId: id, withNext }),
  );

  return (
    <div className={cn('w-full flex justify-around mb-10', className)}>
      {compaireOptions?.map((props) => (
        <CompareResourceLevelUp key={props.compaireKind} {...props} />
      ))}
    </div>
  );
};

export { QuarryUpgradeInfo };
